export enum TSBemerkungSichtbarkeit {
    ALLE = <any>'ALLE',
    INTERN = <any>'INTERN',
    FONDSSUISSE = <any>'FONDSSUISSE',
}

export function getTSBemerkungSichtbarkeitValues(): Array<TSBemerkungSichtbarkeit> {
    return [
        TSBemerkungSichtbarkeit.FONDSSUISSE,
        TSBemerkungSichtbarkeit.INTERN,
        TSBemerkungSichtbarkeit.ALLE,
    ];
}




// WEBPACK FOOTER //
// ./src/app/models/enums/TSBemerkungSichtbarkeit.ts